import React from "react";
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import '@sweetalert2/theme-dark/dark.scss';

const TableTopBar = ({
                       propSelectOption = {
                         isEnable: false,
                         selItems: [15, 30, 50], //미구현
                         setFunc: null,
                       },
                       propExcelExport = {
                         isEnable: false,
                         exportFilename: 'doc.xlsx',
                         getFunc: null,
                       },
                       propExcelDownload = {
                         isEnable: false,
                         getFunc: null,
                       },
                       propPdfExport = {
                         isEnable: false,
                         // exportFilename: 'doc.pdf',
                         getFunc: null,
                       },
                       propPdf = {
                         isEnable: false,
                         getFunc: null,
                       },
                       propDelete = {
                         isEnable: false,
                         delFunc: null,
                       },
                       propReg = {
                         isEnable: false,
                         regFunc: null,
                       },
                       propControl = {
                         isEnable: false,
                         ctlFunc: null,
                       }
                     }) => {

  /* selbox */
  const onChangeSelBox = (e) => {
    let val = e.target.value;
    propSelectOption.setFunc(val);
  };

  return (
      /*<Row className={"table-option-container"}>
        <Col md={12} className={"my-2"}>
          <Row>
            <Col md={3} className={""}>
              {propSelectOption.isEnable ?
                  <Form.Group controlId="formBasicSelectMenu">
                    <Form.Select
                        aria-label="Default select example"
                        className={"input-select fw-bold"}
                        defaultValue={propSelectOption.selItems[0]}
                        onChange={onChangeSelBox}
                    >
                      <option value={15}>15건씩 보기</option>
                      <option value={30}>30건씩 보기</option>
                      <option value={50}>50건씩 보기</option>
                    </Form.Select>
                  </Form.Group>
                  : ''}
            </Col>

            <Col md={9}>
              <Row>
                {/!*
                {propExcelExport.isEnable ?
                    <Col md={2} className={"p-0 text-center"}>
                      <ExportFile
                          propMode={'EXCEL'}
                          propGetData={propExcelExport.getFunc}
                          propFilename={propExcelExport.exportFilename}
                      />
                    </Col> : ''}
                *!/}

                {propExcelDownload.isEnable ?
                    <Col md={2} className={"p-0 text-center"}>
                      <Button
                          type={"button"}
                          className={"button excel-btn bw-bold"}
                          onClick={propExcelDownload.getFunc}
                      >
                        EXCEL
                      </Button>
                    </Col> : ''}

                {propPdfExport.isEnable ?
                    <Col md={2} className={"p-0 text-center"}>
                      <Button
                          type={"button"}
                          className={"button pdf-btn bw-bold"}
                          onClick={propPdfExport.getFunc}
                      >
                        PDF
                      </Button>
                    </Col> : ''}

                {/!*{propPdfExport.isEnable ?
                    <Col md={2} className={"p-0 text-center"}>
                      <ExportFile
                          propMode={'PDF'}
                          propGetData={propPdfExport.getFunc}
                          propFilename={propPdfExport.exportFilename}
                      />
                      <Button
                          type={"button"}
                          className={"button pdf-btn bw-bold"}
                          onClick={propPdfExport.getFunc}
                      >
                        PDF
                      </Button>
                    </Col> : ''}*!/}

                {propDelete.isEnable ?
                    <Col md={2} className={"p-0 text-center"}>
                      <Button
                          type={"button"}
                          className={"btn-danger bw-bold"}
                          onClick={propDelete.delFunc}
                      >
                        삭제
                      </Button>
                    </Col>
                    : ''}

                {propReg.isEnable ?
                    <Col md={2} className={"p-0 text-center"}>
                      <Button
                          type={"button"}
                          className={"delete-btn bw-bold"}
                          onClick={propReg.regFunc}
                      >
                        등록
                      </Button>
                    </Col>
                    : ''}

                {propControl.isEnable ?
                    <Col md={2} className={"p-0 text-center"}>
                      <Button
                          type={"button"}
                          className={"control-btn bw-bold"}
                          onClick={propControl.ctlFunc}
                      >제어</Button>
                    </Col>
                    : ''}

              </Row>
            </Col>
          </Row>
        </Col>
      </Row>*/

      <Row className={"table-option-container"}>
        <Col md={12} className={"my-2"}>
          <Row className={"gy-2"}>
            <Col xxl={4} xl={5} lg={5} md={6} className={""}>
              {propSelectOption.isEnable ?
                  <Form.Group controlId="formBasicSelectMenu">
                    <Form.Select
                        aria-label="Default select example"
                        className={"input-select fw-bold"}
                        defaultValue={propSelectOption.selItems[0]}
                        onChange={onChangeSelBox}
                    >
                      <option value={15}>15건씩 보기</option>
                      <option value={30}>30건씩 보기</option>
                      <option value={50}>50건씩 보기</option>
                    </Form.Select>
                  </Form.Group>
                  : ''}
            </Col>

            <Col xxl={8} xl={7} lg={7} md={6}>
              <Row className={"gy-2"}>
                {propExcelDownload.isEnable ?
                    <Col xxl={3} xl={3} lg={4} md={4} size="lg" className={"d-grid text-center"}>
                      <Button
                          type={"button"}
                          className={"button excel-btn bw-bold"}
                          onClick={propExcelDownload.getFunc}
                      >
                        EXCEL
                      </Button>
                    </Col> : ''}

                {propPdfExport.isEnable ?
                    <Col xxl={3} xl={3} lg={4} md={4} className={"d-grid text-center"}>
                      <Button
                          type={"button"}
                          className={"button pdf-btn bw-bold"}
                          onClick={propPdfExport.getFunc}
                      >
                        PDF
                      </Button>
                    </Col> : ''}

                {propPdf.isEnable ?
                    <Col xxl={3} xl={3} lg={4} md={4} className={"d-grid text-center"}>
                      <Button
                          type={"button"}
                          className={"button pdf-btn bw-bold"}
                          onClick={propPdf.getFunc}
                      >
                        PDF
                      </Button>
                    </Col> : ''}

                {propReg.isEnable ?
                    <Col xxl={3} xl={3} lg={4} md={4} className={"d-grid text-center"}>
                      <Button
                          type={"button"}
                          className={"delete-btn bw-bold"}
                          onClick={propReg.regFunc}
                      >
                        등록
                      </Button>
                    </Col>
                    : ''}

                {/*{propDelete.isEnable ?
                    <Col md={2} className={"p-0 text-center"}>
                      <Button
                          type={"button"}
                          className={"btn-danger bw-bold"}
                          onClick={propDelete.delFunc}
                      >
                        삭제
                      </Button>
                    </Col>
                    : ''}*/}


                {/*{propControl.isEnable ?
                    <Col md={2} className={"p-0 text-center"}>
                      <Button
                          type={"button"}
                          className={"control-btn bw-bold"}
                          onClick={propControl.ctlFunc}
                      >제어</Button>
                    </Col>
                    : ''}*/}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
  );
};
export default TableTopBar;
